export const CHECKOUT_URL = 'https://ingles-esencial-1.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

export const BRAND = 'CM DIGITAL PRO'
export const PRODUCT = 'INGLÉS ESENCIAL 1'
export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/dczoZqNY27nUu3AWDGBN8u/Imagen_de_Codex_13_sept_2026,_19_16_28.png'

export const pains = [
  {
    icon: '😵‍💫',
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos, aplicaciones y tutoriales, pero cada uno enseña algo diferente y no sabes cómo conectar todo.',
  },
  {
    icon: '❓',
    title: 'NO SABES QUÉ APRENDER PRIMERO',
    desc: 'Saludos, pronunciación, vocabulario, preguntas, verbos, conversaciones... hay tantos conceptos que empezar parece complicado.',
  },
  {
    icon: '😰',
    title: 'TE CUESTA HABLAR',
    desc: 'Reconoces algunas palabras, pero cuando llega el momento de decir una frase o responder una pregunta te quedas en blanco.',
  },
  {
    icon: '😩',
    title: 'SIGUES POSTERGANDO',
    desc: 'Quieres aprender inglés, pero pasan las semanas y continúas buscando métodos en lugar de seguir una ruta clara.',
  },
]

export const modules = [
  {
    label: 'MÓDULO 1',
    title: 'HELLO! – MIS PRIMERAS PALABRAS EN INGLÉS',
    desc: 'Aprende saludos, despedidas, expresiones de cortesía y las estructuras esenciales para comenzar a presentarte en inglés.',
  },
  {
    label: 'MÓDULO 2',
    title: 'ABOUT ME – HABLAR DE MÍ',
    desc: 'Aprende a decir tu nombre, edad, país, ciudad, profesión y otra información básica mientras practicas preguntas y respuestas sencillas.',
  },
  {
    label: 'MÓDULO 3',
    title: 'MY EVERYDAY ENGLISH – MI INGLÉS COTIDIANO',
    desc: 'Construye frases sencillas para hablar de tu rutina, trabajo, estudio, gustos, necesidades y actividades de todos los días.',
  },
  {
    label: 'MÓDULO 4',
    title: 'ASK & ANSWER – PREGUNTAR Y RESPONDER',
    desc: 'Aprende preguntas esenciales, cómo responderlas y qué decir cuando necesitas ayuda, repetición o no comprendes algo.',
  },
  {
    label: 'MÓDULO 5',
    title: 'TRAVEL ENGLISH – INGLÉS PARA VIAJAR',
    desc: 'Practica expresiones útiles para aeropuerto, hotel, restaurante, transporte, compras, direcciones y situaciones básicas durante un viaje.',
  },
  {
    label: 'MÓDULO 6',
    title: 'MY FIRST CONVERSATION – MI PRIMERA CONVERSACIÓN REAL',
    desc: 'Integra lo aprendido y practica conversaciones progresivas hasta construir tu primera conversación sencilla en inglés.',
  },
]

export const bonuses = [
  {
    label: '🎁 BONO 1 — GRATIS',
    title: '100 FRASES ESENCIALES PARA LA VIDA REAL™',
    desc: 'Una guía rápida con expresiones prácticas para saludar, conversar, preguntar, viajar, comprar, pedir comida y solicitar ayuda.',
    value: '$7.990',
  },
  {
    label: '🎁 BONO 2 — GRATIS',
    title: 'ENGLISH TRAVEL POCKET GUIDE™',
    desc: 'Una guía de bolsillo con inglés esencial para aeropuerto, migraciones, transporte, hotel, restaurante, compras, direcciones y situaciones importantes.',
    value: '$5.990',
  },
  {
    label: '🎁 BONO 3 — GRATIS',
    title: 'DESAFÍO 7 DÍAS: HABLA INGLÉS DESDE CERO™',
    desc: 'Siete días de pequeñas prácticas para activar saludos, presentaciones, preguntas, respuestas, inglés de viaje y tu primera conversación.',
    value: '$6.990',
  },
  {
    label: '🎁 BONO 4 — GRATIS',
    title: 'PRONUNCIACIÓN SIN MIEDO™',
    desc: 'Una guía práctica para comprender sonidos, practicar palabras y comenzar a pronunciar frases en inglés con mayor claridad y confianza.',
    value: '$8.990',
  },
  {
    label: '🎁 BONO 5 — GRATIS',
    title: 'MY ENGLISH TOOLKIT – KIT ESENCIAL DEL PRINCIPIANTE™',
    desc: 'Flashcards, plantillas, vocabulario, preguntas, frases de viaje, herramientas de práctica y seguimiento para organizar tu aprendizaje.',
    value: '$9.990',
  },
]

export const benefits = [
  {
    icon: '📘',
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre videos, aplicaciones y contenidos y sigue una ruta desde tus primeras palabras hasta conversaciones sencillas.',
  },
  {
    icon: '💬',
    title: 'MÁS INGLÉS PRÁCTICO',
    desc: 'Aprende frases, preguntas, respuestas y expresiones que puedes utilizar en situaciones cotidianas.',
  },
  {
    icon: '✈️',
    title: 'MÁS SEGURIDAD AL VIAJAR',
    desc: 'Empieza a reconocer qué decir en un aeropuerto, hotel, restaurante, tienda, transporte o cuando necesitas pedir ayuda.',
  },
  {
    icon: '🚀',
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construye una base de inglés que puede convertirse en el primer paso para comunicarte mejor, viajar y continuar avanzando hacia niveles superiores.',
  },
]

export const testimonials = [
  {
    name: 'Mariana López',
    role: 'Emprendedora, 34 años',
    place: 'Buenos Aires, Argentina',
    text: 'Tenía aplicaciones, videos y apuntes guardados, pero nunca sabía qué estudiar primero. Con los módulos ordenados finalmente pude empezar desde lo básico y entender cómo construir mis primeras frases sin sentir que tenía que aprender todo de golpe.',
  },
  {
    name: 'Carlos Méndez',
    role: 'Comerciante, 42 años',
    place: 'Córdoba, Argentina',
    text: 'Lo que más me preocupaba era viajar y quedarme en blanco cuando alguien me hablara. La parte de Travel English me ayudó a ordenar las frases que realmente necesito para hotel, restaurante y transporte. Ahora sé mejor qué puedo decir y cómo pedir que repitan.',
  },
  {
    name: 'Lucía Herrera',
    role: 'Administrativa, 29 años',
    place: 'Montevideo, Uruguay',
    text: 'Había intentado estudiar inglés varias veces, pero siempre terminaba abandonando cuando aparecía demasiada gramática. Acá pude empezar con saludos, información personal y frases de todos los días. Sentir que podía decir algo desde el comienzo me ayudó a seguir.',
  },
  {
    name: 'Martín Rojas',
    role: 'Emprendedor, 37 años',
    place: 'Santiago, Chile',
    text: 'Yo entendía algunas palabras sueltas, pero cuando tenía que responder no sabía qué decir. Los ejercicios de preguntas, respuestas y conversaciones me hicieron practicar de una manera mucho más concreta. Dejé de estudiar solamente palabras y empecé a formar frases.',
  },
  {
    name: 'Patricia Ramírez',
    role: 'Comerciante, 46 años',
    place: 'Guadalajara, México',
    text: 'Pensaba que empezar inglés de adulto iba a ser demasiado difícil. Lo que necesitaba era una ruta sencilla. Los módulos, las frases y las prácticas me ayudaron a avanzar paso a paso y ahora tengo una base mucho más ordenada para seguir aprendiendo.',
  },
]

export const faqs = [
  {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% digital.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema comienza desde cero, con tus primeras palabras y saludos en inglés.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Saludos, presentaciones, información personal, vocabulario cotidiano, preguntas y respuestas, inglés para viajar, pronunciación y tus primeras conversaciones sencillas.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye prácticas guiadas, flashcards, plantillas, actividades de conversación y un desafío de 7 días.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos gratis durante esta oferta.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. El precio de la oferta es $19.990, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Recibes acceso digital después de completar tu compra.',
  },
  {
    q: '¿Voy a hablar inglés fluido al terminar?',
    a: 'No. INGLÉS ESENCIAL 1 construye tus bases iniciales para comunicarte en situaciones cotidianas. La fluidez depende de práctica, constancia y tiempo dedicado.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes avanzar y repasar el contenido según tu disponibilidad.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Escríbenos a soportescmdigital@gmail.com.',
  },
]

export const purchaseAlerts = [
  { name: 'Martín Gutiérrez', city: 'Córdoba', country: 'Argentina' },
  { name: 'Leandro Sosa', city: 'Rosario', country: 'Argentina' },
  { name: 'Javier Domínguez', city: 'La Plata', country: 'Argentina' },
  { name: 'Gustavo Peralta', city: 'Mendoza', country: 'Argentina' },
  { name: 'Nicolás Benítez', city: 'Mar del Plata', country: 'Argentina' },
  { name: 'Ariel Cabrera', city: 'San Miguel de Tucumán', country: 'Argentina' },
  { name: 'Facundo Ramírez', city: 'Salta', country: 'Argentina' },
  { name: 'Sergio Villalba', city: 'Neuquén', country: 'Argentina' },
  { name: 'Emiliano Acosta', city: 'Bahía Blanca', country: 'Argentina' },
  { name: 'Rodrigo Medina', city: 'Santa Fe', country: 'Argentina' },
  { name: 'Pablo Ferreyra', city: 'Buenos Aires', country: 'Argentina' },
  { name: 'Hernán Quiroga', city: 'San Juan', country: 'Argentina' },
]
